import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { DvTabLink, DvTabsComponent } from '@devinco/ui/dds';
import { TranslateService } from '@ngx-translate/core';
import { RouteNetworkRouteName } from '@pages/route-network-page/route-network.routes';

@Component({
  selector: 'app-route-network-tabs',
  imports: [DvTabsComponent, RouterOutlet],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './route-network-tabs.component.html',
})
export class RouteNetworkTabsComponent {
  private translate = inject(TranslateService);

  readonly tabLinks: DvTabLink[] = [
    {
      label: this.translate.instant(
        'RouteNetworksPage.RouteNetworkInformationTab'
      ),
      link: RouteNetworkRouteName.Information,
      id: RouteNetworkRouteName.Information,
    },
  ];
}
